(function(){
	'use strict';

	var $scrollBtn = $('.smp-js-scroll-btn'),
	$smpCarousel = $('.smp-banner-carousel');

	if($scrollBtn.length){

		var $parentBanner = $scrollBtn.closest('.smp-banner-carousel'),
		bannerOffset = null;

		if($parentBanner.length){
			bannerOffset = ($parentBanner.offset().top + $parentBanner.outerHeight()) + 'px';
			squiz.fn.smpScrollTopBtn('.smp-js-scroll-btn', bannerOffset);
		}

		$smpCarousel.each(function(){

			var $curCarousel = $(this);

			$(this).find('.smp-banner-carousel__play-btn').click(function(){

				var $cur = $(this);

				if(!$cur.hasClass('active')){
					$cur.addClass('active');
					$curCarousel.carousel('pause');
				}else {
					$cur.removeClass('active');
					$curCarousel.carousel('cycle');
				}

				return false;
			});


		});
	}

}());
